/* THUNDERNOISE · Pop up Sevilla v2 (popup26). JS sin dependencias para sections/atelier-popup26.liquid.
   Ronda 6 (25-09-2026): inglés por defecto (?lang > elección guardada en el selector, clave p26-lang-v2 > inglés), sin pantalla de
   entrada. Cabecera propia con menú de anclas y scrollspy, selector EN / ES (cabecera y menú móvil), revelados al hacer scroll,
   portada con vídeo y parallax, cinta que reacciona al scroll, cuentas atrás, timelines que se dibujan, mapa interactivo, galería con
   arrastre, horario con HOY, apúntate al Coffee Rave con el MISMO formulario de newsletter de la web (Shopify, por fetch con vuelta al
   envío nativo) y pase guardado, barra inferior en móvil y botones magnéticos.
   Solo anima transform, opacity, clip-path y filter. Con prefers-reduced-motion todo queda quieto y completo. */
(function () {
  'use strict';

  var root = document.querySelector('[data-p26]');
  if (!root || root.getAttribute('data-p26-ready')) return;
  root.setAttribute('data-p26-ready', '1');
  window.P26_JS = true;
  root.classList.add('is-js');

  var html = document.documentElement;
  var boot = window.P26_BOOT || {};
  var mm = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var RM = mm('(prefers-reduced-motion: reduce)');
  var FINE = mm('(hover: hover) and (pointer: fine)');
  var KEY = boot.key || 'p26-lang-v2';
  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) { return setTimeout(function () { f(Date.now()); }, 16); };
  var hasIO = 'IntersectionObserver' in window;

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function focusNoScroll(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function lang() { return root.getAttribute('data-lang') === 'es' ? 'es' : 'en'; }
  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function goTo(t) { if (t) t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); }

  /* ---------- Grano ---------- */
  function makeNoise() {
    try {
      var c = document.createElement('canvas');
      c.width = c.height = 128;
      var x = c.getContext('2d');
      if (!x) return;
      var d = x.createImageData(128, 128);
      for (var i = 0; i < d.data.length; i += 4) {
        var v = (Math.random() * 255) | 0;
        d.data[i] = d.data[i + 1] = d.data[i + 2] = v;
        d.data[i + 3] = 40;
      }
      x.putImageData(d, 0, 0);
      root.style.setProperty('--p26-noise', 'url(' + c.toDataURL('image/png') + ')');
    } catch (e) {}
  }

  /* ---------- Wordmarks que siempre caben (se mide el ancho real de las letras) ---------- */
  var fits = [];
  function fitWord(f) {
    var el = f.el, par = el.parentNode;
    if (!par || !el.offsetParent) return;
    el.style.fontSize = '';
    var cs = window.getComputedStyle(el), ps = window.getComputedStyle(par);
    var fs = parseFloat(cs.fontSize) || 0;
    var avail = par.clientWidth - (parseFloat(ps.paddingLeft) || 0) - (parseFloat(ps.paddingRight) || 0) -
      (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var w = 0;
    f.kids.forEach(function (c) { w += c.offsetWidth; });
    if (!fs || !w || avail <= 0) return;
    el.style.fontSize = Math.min(f.max, Math.max(12, fs * (avail * 0.96) / w)).toFixed(2) + 'px';
  }
  function fitAll() { fits.forEach(function (f) { try { fitWord(f); } catch (e) {} }); }
  function initFit() {
    [['.p26-end-word', 210]].forEach(function (d) {
      var el = $(d[0]);
      if (el) fits.push({ el: el, max: d[1], kids: $$('.p26-ch', el) });
    });
    if (!fits.length) return;
    fitAll();
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(fitAll);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitAll);
    }
    window.addEventListener('load', fitAll);
    var ft = 0;
    window.addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(fitAll, 120); });
  }

  /* ---------- Idioma ---------- */
  var metaDesc = document.querySelector('meta[name="description"]');
  var langHooks = [];
  var ATTRS = [['aria', 'aria-label'], ['ph', 'placeholder'], ['alt', 'alt']];
  function applyLang(l) {
    l = l === 'es' ? 'es' : 'en';
    root.setAttribute('data-lang', l);
    root.setAttribute('lang', l);
    html.setAttribute('lang', l);
    $$('[data-p26-setlang]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-p26-setlang') === l));
    });
    ATTRS.forEach(function (a) {
      $$('[data-' + a[0] + '-' + l + ']').forEach(function (el) { el.setAttribute(a[1], el.getAttribute('data-' + a[0] + '-' + l)); });
    });
    var t = root.getAttribute('data-title-' + l);
    if (t) document.title = t;
    var ds = root.getAttribute('data-desc-' + l);
    if (ds && metaDesc) metaDesc.setAttribute('content', ds);
  }
  function afterLang() { langHooks.forEach(function (f) { try { f(); } catch (e) {} }); }
  function setLang(l, instant) {
    if (l === root.getAttribute('data-lang')) { applyLang(l); return; }
    if (instant || RM) { applyLang(l); afterLang(); return; }
    root.classList.add('is-switching');
    setTimeout(function () {
      applyLang(l);
      afterLang();
      raf(function () { raf(function () { root.classList.remove('is-switching'); }); });
    }, 220);
  }
  $$('[data-p26-setlang]').forEach(function (b) {
    b.addEventListener('click', function () {
      var l = b.getAttribute('data-p26-setlang');
      lsSet(KEY, l);
      setLang(l);
    });
  });
  applyLang(root.getAttribute('data-lang'));

  var started = false;

  /* ---------- Revelados y contadores ---------- */
  function runCount(el, delay) {
    if (el.getAttribute('data-p26-counted')) return;
    el.setAttribute('data-p26-counted', '1');
    var to = parseInt(el.getAttribute('data-p26-count'), 10) || 0;
    var final = String(to);
    if (RM || !root.classList.contains('p26-anim')) { el.textContent = final; return; }
    el.textContent = '0';
    var dur = to > 50 ? 1800 : 1500, t0 = 0, done = false;
    var finish = function () { done = true; el.textContent = final; };
    setTimeout(function () {
      var step = function (t) {
        if (done) return;
        if (!t0) t0 = t;
        var p = clamp((t - t0) / dur, 0, 1);
        var e = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
        el.textContent = String(Math.round(to * e));
        if (p < 1) raf(step); else finish();
      };
      raf(step);
    }, delay || 0);
    setTimeout(finish, (delay || 0) + dur + 400);
  }
  function onIn(el) {
    if (el.hasAttribute && el.hasAttribute('data-p26-count')) runCount(el, 300);
    $$('[data-p26-count]', el).forEach(function (c) { runCount(c, 380); });
  }
  function initReveal() {
    $$('[data-p26-stagger]').forEach(function (g) {
      $$('[data-p26-reveal]', g).forEach(function (el, i) {
        if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', (i * 0.08).toFixed(2) + 's');
      });
    });
    $$('.p26-strip [data-p26-reveal]').forEach(function (el, i) { el.style.setProperty('--d', (Math.min(i, 3) * 0.1).toFixed(2) + 's'); });
    $$('.p26-pin').forEach(function (p, i) { p.style.setProperty('--k', String(i)); });
    var targets = $$('[data-p26-reveal],[data-p26-mask],[data-p26-map],[data-p26-letters]');
    if (!hasIO || RM) {
      targets.forEach(function (el) { el.classList.add('is-in'); onIn(el); });
      return;
    }
    var pending = targets.slice();
    var reveal = function (el) {
      if (el.classList.contains('is-in')) return;
      el.classList.add('is-in');
      onIn(el);
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
    /* Red de seguridad: lo que esté en pantalla y el observer no haya disparado se revela al parar el scroll. */
    var sweep = function () {
      var w = window.innerWidth, h = window.innerHeight;
      pending = pending.filter(function (el) {
        if (el.classList.contains('is-in')) return false;
        var r = el.getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < h * 0.94 && r.right > 0 && r.left < w) {
          reveal(el);
          try { io.unobserve(el); } catch (e) {}
          return false;
        }
        return true;
      });
    };
    var st = 0;
    var later = function () { clearTimeout(st); st = setTimeout(sweep, 260); };
    window.addEventListener('scroll', later, { passive: true });
    var strip = $('[data-p26-strip]');
    if (strip) strip.addEventListener('scroll', later, { passive: true });
    langHooks.push(later);
    setTimeout(sweep, 1400);
  }

  /* ---------- Vídeo de la portada ---------- */
  function initVideo() {
    var hero = $('[data-p26-hero]'), v = $('[data-p26-video]'), tg = $('[data-p26-vtoggle]');
    if (!hero || !v) return;
    var conn = navigator.connection || {};
    if (RM || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
    var src = mm('(min-width: 990px)') ? v.getAttribute('data-src-l') : v.getAttribute('data-src-s');
    if (!src) return;
    var userPaused = false, loaded = false, visible = true;
    var play = function () {
      if (userPaused || !visible || document.hidden) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    var load = function () {
      if (loaded) return;
      loaded = true;
      v.muted = true;
      v.setAttribute('muted', '');
      v.src = src;
      play();
    };
    v.addEventListener('playing', function () { hero.classList.add('is-playing'); if (tg) tg.hidden = false; });
    if (tg) {
      tg.addEventListener('click', function () {
        userPaused = !userPaused;
        tg.setAttribute('aria-pressed', String(userPaused));
        if (userPaused) v.pause(); else play();
      });
    }
    if (hasIO) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (!loaded) return;
        if (visible) play(); else v.pause();
      }, { threshold: 0.05 }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () { if (loaded) { if (document.hidden) v.pause(); else play(); } });
    var go = function () { setTimeout(load, 150); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  /* ---------- Cinta ---------- */
  var mqs = [], mqBox = $('[data-p26-mq]'), mqVisible = false, mqRunning = false, mqHover = false;
  var mqLastT = 0, mqPrevY = window.pageYOffset, mqMul = 1, mqSign = 1;
  function mqBuild() {
    var old = {};
    mqs.forEach(function (m, i) { old[i] = m.x; });
    mqs = [];
    $$('[data-p26-mq-track]').forEach(function (tr, i) {
      $$('.is-clone', tr).forEach(function (c) { c.parentNode.removeChild(c); });
      var g = $('.p26-mq-g', tr);
      if (!g) return;
      var w = g.getBoundingClientRect().width;
      if (!w) return;
      var need = Math.ceil((window.innerWidth * 1.25) / w) + 1;
      for (var k = 0; k < need; k++) {
        var c = g.cloneNode(true);
        c.classList.add('is-clone');
        c.setAttribute('aria-hidden', 'true');
        tr.appendChild(c);
      }
      mqs.push({ tr: tr, w: w, x: (old[i] || 0) % w, dir: parseFloat(tr.getAttribute('data-dir')) || -1 });
    });
  }
  function mqTick(t) {
    if (!mqVisible || RM) { mqRunning = false; mqLastT = 0; return; }
    var dt = mqLastT ? Math.min(64, t - mqLastT) : 16;
    mqLastT = t;
    var y = window.pageYOffset, dy = y - mqPrevY;
    mqPrevY = y;
    if (dy > 0.5) mqSign = 1; else if (dy < -0.5) mqSign = -1;
    var target = mqHover ? 0.12 : 1 + Math.min(Math.abs(dy) / Math.max(dt, 1) * 16, 70) * 0.09;
    mqMul += (target - mqMul) * 0.08;
    var base = window.innerWidth < 750 ? 48 : 72;
    mqs.forEach(function (m) {
      m.x += m.dir * mqSign * base * mqMul * dt / 1000;
      if (m.x <= -m.w) m.x += m.w;
      if (m.x > 0) m.x -= m.w;
      m.tr.style.transform = 'translate3d(' + m.x.toFixed(2) + 'px,0,0)';
    });
    raf(mqTick);
  }
  function mqStart() { if (!mqRunning && mqVisible && !RM) { mqRunning = true; raf(mqTick); } }
  function initMarquee() {
    if (!mqBox) return;
    mqBuild();
    if (RM) return;
    if (FINE) {
      mqBox.addEventListener('pointerenter', function () { mqHover = true; });
      mqBox.addEventListener('pointerleave', function () { mqHover = false; });
    }
    if (hasIO) {
      new IntersectionObserver(function (en) { mqVisible = en[0].isIntersecting; mqStart(); }, { threshold: 0 }).observe(mqBox);
    } else { mqVisible = true; mqStart(); }
    langHooks.push(mqBuild);
  }

  /* ---------- Scroll: progreso, cabecera, parallax, timelines, scrollspy ---------- */
  var vh = window.innerHeight, docH = 1, ticking = false;
  var head = $('[data-p26-head]'), prog = $('[data-p26-progress]'), headSolid = false;
  var heroEl = $('[data-p26-hero]'), heroMedia = $('[data-p26-hero-media]'), heroCopy = $('[data-p26-hero-copy]'), heroVis = true;
  var drift = $('[data-p26-drift]'), driftSec = drift ? drift.closest('section') : null, driftVis = false;
  var chipsBox = $('[data-p26-chips]');
  var spyIds = [], spyEls = [], spyCur = null;
  $$('.p26-chip[data-p26-spy]').forEach(function (a) {
    var id = a.getAttribute('data-p26-spy'), t = document.getElementById(id);
    if (t) { spyIds.push(id); spyEls.push(t); }
  });
  var tls = $$('[data-p26-tl]').map(function (el) {
    return {
      el: el,
      fill: $('[data-p26-tl-fill]', el),
      items: $$('[data-p26-tl-item]', el).map(function (li) { return { el: li, y: 0, lit: false }; }),
      h: 1, vis: !hasIO, act: -2
    };
  });
  function headH() { return head ? head.offsetHeight : 0; }
  function measure() {
    vh = window.innerHeight;
    var hh = headH();
    if (hh) root.style.setProperty('--p26-headh', hh + 'px');
    docH = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
    tls.forEach(function (t) {
      t.h = t.el.offsetHeight || 1;
      t.items.forEach(function (it) { it.y = it.el.offsetTop + 21; });
    });
  }
  function setSpy(id) {
    if (id === spyCur) return;
    spyCur = id;
    $$('[data-p26-spy]').forEach(function (a) {
      if (a.getAttribute('data-p26-spy') === id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    if (!chipsBox || !id) return;
    var chip = $('.p26-chip[data-p26-spy="' + id + '"]', chipsBox);
    if (!chip) return;
    var br = chipsBox.getBoundingClientRect(), cr = chip.getBoundingClientRect();
    if (cr.left < br.left + 12 || cr.right > br.right - 20) {
      var to = chipsBox.scrollLeft + (cr.left - br.left) - 16;
      try { chipsBox.scrollTo({ left: to, behavior: RM ? 'auto' : 'smooth' }); } catch (e) { chipsBox.scrollLeft = to; }
    }
  }
  function frame() {
    ticking = false;
    var sy = window.pageYOffset;
    if (prog) prog.style.transform = 'scaleX(' + clamp(sy / Math.max(1, docH - vh), 0, 1).toFixed(4) + ')';
    var solid = sy > 12;
    if (head && solid !== headSolid) { headSolid = solid; head.classList.toggle('is-solid', solid); }
    if (spyEls.length) {
      var line = headH() + (vh - headH()) * 0.3, pick = null, passed = null;
      for (var i = 0; i < spyEls.length; i++) {
        var r = spyEls[i].getBoundingClientRect();
        if (r.top <= line) passed = spyIds[i];
        if (r.top <= line && r.bottom > line && !pick) pick = spyIds[i];
      }
      var heroR = heroEl ? heroEl.getBoundingClientRect() : null;
      if (heroR && heroR.bottom > line) pick = null; else if (!pick) pick = passed;
      setSpy(pick);
    }
    /* r5: la portada se recalcula siempre que este cerca de pantalla (no solo cuando el observer ya
       ha avisado: al volver arriba de golpe el scroll llegaba antes que el observer y la portada se
       quedaba a medias). Arriba del todo, opacidad 1 y sin estilos en linea. */
    if (!RM && heroEl && heroMedia) {
      var hr = heroEl.getBoundingClientRect();
      if (heroVis || hr.bottom > -vh) {
        var p = sy <= 1 ? 0 : clamp(-hr.top / Math.max(1, hr.height), 0, 1);
        if (p === 0) {
          heroMedia.style.transform = '';
          if (heroCopy) { heroCopy.style.transform = ''; heroCopy.style.opacity = ''; }
        } else {
          heroMedia.style.transform = 'translate3d(0,' + (p * 8).toFixed(2) + '%,0) scale(' + (1 + p * 0.12).toFixed(4) + ')';
          if (heroCopy) {
            heroCopy.style.transform = 'translate3d(0,' + (-p * 70).toFixed(1) + 'px,0)';
            heroCopy.style.opacity = String((1 - p * 0.75).toFixed(3));
          }
        }
      }
    }
    tls.forEach(function (t) {
      if (!t.vis || !t.fill) return;
      var rr = t.el.getBoundingClientRect();
      var span = Math.max(1, t.h - 40);
      var pp = RM ? 1 : clamp((vh * 0.62 - rr.top - 14) / span, 0, 1);
      t.fill.style.transform = 'scaleY(' + pp.toFixed(4) + ')';
      var reach = 14 + pp * span, act = -1;
      t.items.forEach(function (it, i) {
        var lit = reach >= it.y;
        if (lit !== it.lit) { it.lit = lit; it.el.classList.toggle('is-lit', lit); }
        if (lit) act = i;
      });
      if (act !== t.act) {
        t.act = act;
        t.items.forEach(function (it, i) { it.el.classList.toggle('is-active', i === act); });
      }
    });
    if (!RM && drift && driftVis) {
      var dr = driftSec.getBoundingClientRect();
      drift.style.transform = 'translate3d(' + ((dr.top - vh) * 0.45).toFixed(1) + 'px,0,0)';
    }
  }
  function onScroll() { if (!ticking) { ticking = true; raf(frame); } }
  function initScroll() {
    if (hasIO) {
      if (heroEl) new IntersectionObserver(function (en) { heroVis = en[0].isIntersecting; onScroll(); }, { threshold: 0 }).observe(heroEl);
      if (driftSec) new IntersectionObserver(function (en) { driftVis = en[0].isIntersecting; onScroll(); }, { threshold: 0 }).observe(driftSec);
      tls.forEach(function (t) {
        new IntersectionObserver(function (en) { t.vis = en[0].isIntersecting; onScroll(); }, { rootMargin: '20% 0px 20% 0px', threshold: 0 }).observe(t.el);
      });
    } else { driftVis = true; }
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    var lastW = window.innerWidth, rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        measure();
        if (window.innerWidth !== lastW) { lastW = window.innerWidth; if (mqBox) mqBuild(); }
        onScroll();
      }, 150);
    });
    window.addEventListener('load', function () { measure(); onScroll(); });
    window.addEventListener('pageshow', function () { measure(); onScroll(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); if (mqBox) mqBuild(); onScroll(); });
    langHooks.push(function () { measure(); onScroll(); });
    onScroll();
  }

  /* ---------- Cuentas atrás ---------- */
  function initCountdowns() {
    var animOK = false;
    var cds = $$('[data-p26-cd]').map(function (el) {
      var s = Date.parse(el.getAttribute('data-start'));
      var e = Date.parse(el.getAttribute('data-end'));
      if (isNaN(e) || e <= s) e = s + 3600000;
      var o = { el: el, s: s, e: e, state: '', units: {} };
      $$('[data-u]', el).forEach(function (u) {
        u.textContent = '';
        var slots = [];
        for (var i = 0; i < 2; i++) {
          var slot = document.createElement('span');
          slot.className = 'p26-dg';
          var inner = document.createElement('span');
          inner.textContent = '0';
          slot.appendChild(inner);
          u.appendChild(slot);
          slots.push(slot);
        }
        o.units[u.getAttribute('data-u')] = { slots: slots, val: '00' };
      });
      return o;
    }).filter(function (o) { return !isNaN(o.s); });
    if (!cds.length) return;
    function put(unit, str) {
      if (!unit || unit.val === str) return;
      for (var i = 0; i < 2; i++) {
        var ch = str.charAt(i), slot = unit.slots[i];
        if (unit.val.charAt(i) === ch) continue;
        var cur = slot.lastElementChild;
        if (!animOK || RM) {
          slot.textContent = '';
          var s0 = document.createElement('span');
          s0.textContent = ch;
          slot.appendChild(s0);
          continue;
        }
        if (cur) {
          cur.className = 'is-out';
          (function (c) { setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 520); })(cur);
        }
        var n = document.createElement('span');
        n.className = 'is-in';
        n.textContent = ch;
        slot.appendChild(n);
      }
      unit.val = str;
    }
    function tick() {
      var now = Date.now();
      cds.forEach(function (o) {
        var st = now < o.s ? 'soon' : (now < o.e ? 'live' : 'done');
        if (st !== o.state) { o.state = st; o.el.setAttribute('data-state', st); }
        if (st === 'soon') {
          var d = Math.floor((o.s - now) / 1000);
          put(o.units.d, pad(Math.min(99, Math.floor(d / 86400))));
          put(o.units.h, pad(Math.floor((d % 86400) / 3600)));
          put(o.units.m, pad(Math.floor((d % 3600) / 60)));
          put(o.units.s, pad(d % 60));
        }
      });
    }
    tick();
    animOK = true;
    var loop = function () { tick(); setTimeout(loop, 1005 - (Date.now() % 1000)); };
    setTimeout(loop, 1005 - (Date.now() % 1000));
  }

  /* ---------- En vivo (hora de Madrid): hitos en marcha, HOY en el horario, textos de "hoy" que caducan ---------- */
  function madridDate() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return o.year + '-' + o.month + '-' + o.day;
    } catch (e) {
      var d = new Date();
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
  }
  var goneSig = '';
  function updateLive() {
    var now = Date.now(), today = madridDate();
    $$('[data-p26-tl-item]').forEach(function (li) {
      var s = Date.parse(li.getAttribute('data-start')), e = Date.parse(li.getAttribute('data-end'));
      if (isNaN(s)) return;
      if (isNaN(e)) e = s + 3600000;
      li.classList.toggle('is-now', now >= s && now < e);
      li.classList.toggle('is-past', now >= e);
    });
    $$('[data-p26-days] [data-date]').forEach(function (li) {
      var d = li.getAttribute('data-date'), isT = d === today;
      li.classList.toggle('is-today', isT);
      li.classList.toggle('is-past', d < today);
      if (isT) li.setAttribute('aria-current', 'date'); else li.removeAttribute('aria-current');
    });
    var sig = '';
    $$('[data-p26-until]').forEach(function (el) {
      var gone = today > el.getAttribute('data-p26-until');
      el.classList.toggle('is-gone', gone);
      sig += gone ? '1' : '0';
    });
    $$('[data-p26-from]').forEach(function (el) { el.hidden = today < el.getAttribute('data-p26-from'); });
    if (goneSig && sig !== goneSig && mqBox) mqBuild();
    goneSig = sig;
  }

  /* ---------- Mapa ---------- */
  function initMap() {
    var map = $('[data-p26-map]');
    if (!map) return;
    var pins = $$('[data-p26-pin]'), legs = $$('[data-p26-leg]'), cur = null;
    var sel = function (n, fromLegend) {
      if (n && cur === n) n = null;
      cur = n;
      pins.forEach(function (p) {
        var on = p.getAttribute('data-p26-pin') === n;
        p.classList.toggle('is-sel', on);
        var b = $('.p26-pin-btn', p), c = b ? document.getElementById(b.getAttribute('aria-controls')) : null;
        if (b) b.setAttribute('aria-expanded', String(on));
        if (c) c.hidden = !on;
      });
      legs.forEach(function (l) {
        var on = l.getAttribute('data-p26-leg') === n;
        l.classList.toggle('is-sel', on);
        var b = $('.p26-leg-btn', l);
        if (b) b.setAttribute('aria-pressed', String(on));
      });
      if (n && fromLegend) {
        var r = map.getBoundingClientRect();
        if (r.top < headH() + 10 || r.bottom > window.innerHeight - 20) map.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
      }
    };
    var hl = function (n, on) {
      pins.forEach(function (p) { if (p.getAttribute('data-p26-pin') === n) p.classList.toggle('is-hl', on); });
      legs.forEach(function (l) { if (l.getAttribute('data-p26-leg') === n) l.classList.toggle('is-hl', on); });
    };
    pins.forEach(function (p) {
      var n = p.getAttribute('data-p26-pin'), b = $('.p26-pin-btn', p);
      if (!b) return;
      b.addEventListener('click', function (e) { e.stopPropagation(); sel(n, false); });
      if (FINE) {
        b.addEventListener('pointerenter', function () { hl(n, true); });
        b.addEventListener('pointerleave', function () { hl(n, false); });
      }
    });
    legs.forEach(function (l) {
      var n = l.getAttribute('data-p26-leg'), b = $('.p26-leg-btn', l);
      if (!b) return;
      b.addEventListener('click', function (e) { e.stopPropagation(); sel(n, true); });
      if (FINE) {
        l.addEventListener('pointerenter', function () { hl(n, true); });
        l.addEventListener('pointerleave', function () { hl(n, false); });
      }
    });
    document.addEventListener('click', function (e) {
      if (cur && !(e.target.closest && e.target.closest('.p26-pin-card'))) sel(null);
    });
    document.addEventListener('keydown', function (e) {
      if (cur && (e.key === 'Escape' || e.key === 'Esc')) {
        var p = $('[data-p26-pin="' + cur + '"] .p26-pin-btn');
        sel(null);
        if (p && map.contains(document.activeElement)) focusNoScroll(p);
      }
    });
  }

  /* ---------- Galería ---------- */
  function initStrip() {
    var s = $('[data-p26-strip]'), bar = $('[data-p26-strip-bar]');
    if (!s) return;
    var upd = function () {
      if (!bar) return;
      var sw = s.scrollWidth, cw = s.clientWidth, max = sw - cw;
      var vis = sw > 0 ? clamp(cw / sw, 0.08, 1) : 1;
      var p = max > 0 ? s.scrollLeft / max : 0;
      var bw = bar.parentNode.clientWidth || 1;
      bar.style.transform = 'translate3d(' + (p * (1 - vis) * bw).toFixed(1) + 'px,0,0) scaleX(' + vis.toFixed(4) + ')';
    };
    var tk = false;
    s.addEventListener('scroll', function () { if (!tk) { tk = true; raf(function () { tk = false; upd(); }); } }, { passive: true });
    window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();
    var down = false, moved = false, sx = 0, sl = 0, pid = null;
    s.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = s.scrollLeft; pid = e.pointerId;
    });
    s.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        s.classList.add('is-drag');
        try { s.setPointerCapture(pid); } catch (er) {}
      }
      if (moved) { s.scrollLeft = sl - dx; e.preventDefault(); }
    });
    var up = function () {
      if (!down) return;
      down = false;
      if (moved) { s.classList.remove('is-drag'); try { s.releasePointerCapture(pid); } catch (er) {} }
    };
    s.addEventListener('pointerup', up);
    s.addEventListener('pointercancel', up);
    s.addEventListener('lostpointercapture', up);
    s.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- Barra inferior ---------- */
  function initBar() {
    var bar = $('[data-p26-bar]');
    if (!bar) return;
    if (!hasIO || !heroEl) { bar.classList.add('is-on'); return; }
    new IntersectionObserver(function (en) {
      bar.classList.toggle('is-on', !en[0].isIntersecting);
    }, { rootMargin: '-40% 0px 0px 0px', threshold: 0 }).observe(heroEl);
  }

  /* ---------- Menú a pantalla completa (móvil) ---------- */
  var menu = $('[data-p26-menu]'), menuBtn = $('[data-p26-menu-open]'), menuOpen = false, menuT = 0;
  function menuFocusables() { return $$('a[href],button', menu); }
  function openMenu() {
    if (!menu || menuOpen) return;
    menuOpen = true;
    clearTimeout(menuT);
    menu.hidden = false;
    html.style.overflow = 'hidden';
    menuBtn.setAttribute('aria-expanded', 'true');
    void menu.offsetWidth;
    menu.classList.add('is-open');
    focusNoScroll(menuFocusables()[0]);
  }
  function closeMenu(keepFocus) {
    if (!menu || !menuOpen) return;
    menuOpen = false;
    menu.classList.remove('is-open');
    html.style.overflow = '';
    menuBtn.setAttribute('aria-expanded', 'false');
    menuT = setTimeout(function () { menu.hidden = true; }, RM ? 0 : 700);
    if (!keepFocus) focusNoScroll(menuBtn);
  }
  function initMenu() {
    if (!menu || !menuBtn) return;
    menuBtn.addEventListener('click', openMenu);
    var c = $('[data-p26-menu-close]', menu);
    if (c) c.addEventListener('click', function () { closeMenu(); });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeMenu(); return; }
      if (e.key !== 'Tab') return;
      var f = menuFocusables(), i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); focusNoScroll(f[f.length - 1]); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); focusNoScroll(f[0]); }
    });
    window.addEventListener('resize', function () { if (menuOpen && window.innerWidth >= 990) closeMenu(true); });
  }

  /* ---------- Anclas suaves (la cabecera fija ya se descuenta con scroll-margin) ---------- */
  function initAnchors() {
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !root.contains(a)) return;
      var id = a.getAttribute('href').slice(1);
      var t = id ? document.getElementById(id) : null;
      if (!t) return;
      e.preventDefault();
      if (menu && menu.contains(a)) closeMenu(true);
      goTo(t);
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      focusNoScroll(t);
      try { history.replaceState(history.state, '', '#' + id); } catch (er) {}
    });
  }

  /* ---------- Botones magnéticos (escritorio) ---------- */
  function initMagnet() {
    if (!FINE || RM) return;
    $$('[data-p26-magnet]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / (r.width / 2);
        var y = (e.clientY - r.top - r.height / 2) / (r.height / 2);
        b.style.setProperty('--mx', (clamp(x, -1, 1) * 7).toFixed(2) + 'px');
        b.style.setProperty('--my', (clamp(y, -1, 1) * 6).toFixed(2) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
    });
  }

  /* ---------- Apúntate al Coffee Rave = el MISMO formulario de newsletter de la web ----------
     Formulario de cliente de Shopify (form_type customer, contact[email], contact[tags] newsletter,coffee-rave-27-09 y, si lo pone,
     contact[first_name]). 1) Se envía por fetch al action del formulario: si la respuesta final trae customer_posted=true, sale el pase.
     2) Si Shopify pide reto (URL con /challenge), si la red falla o la respuesta no se entiende, envío nativo (recarga) y al volver con
     customer_posted=true la sección ya pinta el pase. 3) Sin JS, el formulario nativo funciona solo.
     Protección antispam de Shopify (hCaptcha, igual que el formulario de la web): cuando está enganchada, su listener saca el token y
     llama a form.submit(); ese submit lo redirigimos aquí al envío por fetch, así el token viaja en el FormData.
     Evento de Klaviyo "Coffee Rave RSVP" (client/events) como registro secundario: no suscribe a nadie y no bloquea. */
  var P26_SOURCE = 'Pop up Sevilla · Coffee Rave 27-09';
  function klaviyoEvent(company, email, name, lng) {
    if (!company || !email || !window.fetch) return;
    try {
      var prof = { email: email, properties: { coffee_rave_27_09: true, coffee_rave_27_09_idioma: lng, coffee_rave_27_09_source: P26_SOURCE } };
      if (name) prof.first_name = name;
      var ev = { data: { type: 'event', attributes: {
        properties: { source: P26_SOURCE, event: 'Coffee Rave', event_date: '2026-09-27', place: 'Calle Lineros, 13 · Sevilla', language: lng },
        metric: { data: { type: 'metric', attributes: { name: 'Coffee Rave RSVP' } } },
        profile: { data: { type: 'profile', attributes: prof } } } } };
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2025-10-15' },
        body: JSON.stringify(ev)
      }).catch(function () {});
    } catch (e) {}
  }
  function initRsvp() {
    var box = $('[data-p26-rsvp]');
    if (!box) return;
    var form = document.getElementById('P26Form'), wrap = $('[data-p26-pass-wrap]', box);
    var PASS = 'p26-pase', PEND = 'p26-pase-pend', company = box.getAttribute('data-klaviyo') || '';
    var read = function (k) { try { return JSON.parse(lsGet(k) || 'null'); } catch (e) { return null; } };
    var reset = $('[data-p26-pass-reset]', box), passMsg = $('[data-p26-pass-msg]', box);
    /* Mensajes con los dos idiomas dentro: el CSS enseña el que toca, también si se cambia de idioma después. */
    var both = function (k) {
      return '<span lang="es">' + esc(box.getAttribute('data-m-' + k + '-es')) + '</span><span lang="en">' + esc(box.getAttribute('data-m-' + k + '-en')) + '</span>';
    };
    function showPass(p, fresh, kind) {
      if (!wrap) return;
      var nm = $('[data-p26-pass-name]', wrap), row = $('[data-p26-pass-name-row]', wrap);
      var who = p && (p.n || p.e) ? (p.n || p.e) : '';
      if (nm) nm.textContent = who;
      if (row) row.hidden = !who;
      if (passMsg && kind) passMsg.innerHTML = both(kind);
      $$('.p26-pass-grid p', wrap).forEach(function (el, i) { el.style.setProperty('--k', String(i)); });
      wrap.hidden = false;
      if (reset) reset.hidden = !form;
      if (fresh) {
        wrap.classList.remove('is-new');
        void wrap.offsetWidth;
        wrap.classList.add('is-new');
        focusNoScroll($('#p26-pass-h', wrap));
      }
      measure();
    }
    var posted = wrap ? wrap.getAttribute('data-p26-posted') : '';
    var pend = read(PEND);
    if (pend && (!pend.t || Date.now() - pend.t > 3600000)) pend = null;
    if (posted) {
      var p0 = pend || read(PASS) || {};
      lsSet(PASS, JSON.stringify(p0));
      lsSet(PEND, null);
      if (pend && pend.e) klaviyoEvent(company, pend.e, pend.n, pend.l || lang());
      showPass(p0, true, null);
      setTimeout(function () { goTo(document.getElementById('newsletter')); }, 300);
    } else {
      lsSet(PEND, null);
      var saved = read(PASS);
      if (saved) showPass(saved, false, 'ok');
      var srv = $('[data-p26-srv-err]', box);
      if (srv && srv.getAttribute('data-p26-srv-err')) setTimeout(function () { goTo(document.getElementById('newsletter')); }, 300);
    }
    if (!form) return;
    form.noValidate = true;
    var mail = form.querySelector('#P26Mail'), name = form.querySelector('#P26Name'), cons = form.querySelector('#P26Consent'), msg = form.querySelector('[data-p26-msg]');
    var btn = form.querySelector('button[type="submit"]'), btnTxt = form.querySelector('[data-p26-btn-txt]'), btnHTML = btnTxt ? btnTxt.innerHTML : '';
    if (!mail || !cons || !msg || !btn) return;
    var say = function (k, err) {
      msg.innerHTML = k ? both(k) : '';
      msg.classList.toggle('is-error', !!err);
      msg.setAttribute('data-p26-srv-err', '');
    };
    var busy = false, sent = false, watch = 0, pass = null;
    var restore = function () { busy = false; btn.disabled = false; if (btnTxt) btnTxt.innerHTML = btnHTML; };
    if (reset) reset.addEventListener('click', function () {
      lsSet(PASS, null);
      wrap.hidden = true;
      wrap.classList.remove('is-new');
      wrap.removeAttribute('data-p26-posted');
      if (passMsg) passMsg.innerHTML = '';
      form.reset();
      say('');
      restore();
      focusNoScroll(mail);
      measure();
    });
    mail.addEventListener('input', function () { mail.removeAttribute('aria-invalid'); if (msg.classList.contains('is-error')) say(''); });
    cons.addEventListener('change', function () { cons.parentNode.classList.remove('is-invalid'); cons.removeAttribute('aria-invalid'); if (msg.classList.contains('is-error')) say(''); });
    function success(kind) {
      clearTimeout(watch);
      restore();
      lsSet(PASS, JSON.stringify(pass));
      lsSet(PEND, null);
      klaviyoEvent(company, pass.e, pass.n, pass.l);
      showPass(pass, true, kind);
    }
    function toNative() {
      clearTimeout(watch);
      sent = true;
      lsSet(PEND, JSON.stringify(pass));
      try { HTMLFormElement.prototype.submit.call(form); } catch (e) { restore(); say('err-envio', true); }
    }
    function readResp(t) {
      try {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var w = d.querySelector('[data-p26-pass-wrap][data-p26-posted]');
        if (w) return w.getAttribute('data-p26-posted') === 'ya' ? 'ya' : 'ok';
        var e = d.querySelector('[data-p26-srv-err]');
        if (e && e.getAttribute('data-p26-srv-err')) return e.getAttribute('data-p26-srv-err');
      } catch (er) {}
      return 'native';
    }
    function viaFetch() {
      if (sent || !pass) return;
      sent = true;
      clearTimeout(watch);
      var url = (form.getAttribute('action') || '/contact').split('#')[0], fd;
      try { fd = new FormData(form); } catch (e) { sent = false; toNative(); return; }
      if (!window.fetch) { sent = false; toNative(); return; }
      var ctl = window.AbortController ? new AbortController() : null;
      var to = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
      fetch(url, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow', headers: { Accept: 'text/html' }, signal: ctl ? ctl.signal : undefined })
        .then(function (r) {
          clearTimeout(to);
          var u = r.url || '';
          if (/[?&]customer_posted=true/.test(u)) return 'ok';
          if (/\/challenge/.test(u) || !r.ok) return 'native';
          return r.text().then(readResp);
        })
        .then(function (res) {
          if (res === 'ok' || res === 'ya') { success(res); return; }
          if (res === 'email') { sent = false; restore(); mail.setAttribute('aria-invalid', 'true'); say('err-email', true); mail.focus(); return; }
          sent = false;
          toNative();
        }, function () { clearTimeout(to); sent = false; toNative(); });
    }
    /* La protección de Shopify guarda este submit al engancharse (en el primer focus del formulario) y lo llama tras sacar el token. */
    try { form.submit = viaFetch; } catch (e) {}
    function challengeOpen() {
      var fr = document.querySelectorAll('iframe[src*="hcaptcha"]');
      for (var i = 0; i < fr.length; i++) {
        if (!/challenge/.test(fr[i].src || '')) continue;
        try { if (window.getComputedStyle(fr[i]).visibility === 'visible') return true; } catch (e) {}
      }
      return false;
    }
    function armWatch() {
      var t0 = Date.now();
      clearTimeout(watch);
      var check = function () {
        if (sent) return;
        if (challengeOpen() && Date.now() - t0 < 180000) { watch = setTimeout(check, 3000); return; }
        toNative();
      };
      watch = setTimeout(check, 12000);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) { e.stopImmediatePropagation(); return; }
      var email = (mail.value || '').trim(), nm = name ? (name.value || '').trim().slice(0, 60) : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { e.stopImmediatePropagation(); mail.setAttribute('aria-invalid', 'true'); say('err-email', true); mail.focus(); return; }
      if (!cons.checked) { e.stopImmediatePropagation(); cons.setAttribute('aria-invalid', 'true'); cons.parentNode.classList.add('is-invalid'); say('err-consent', true); cons.focus(); return; }
      mail.value = email;
      if (name) name.value = nm;
      busy = true;
      sent = false;
      btn.disabled = true;
      if (btnTxt) btnTxt.innerHTML = both('sending');
      say('');
      pass = { n: nm, e: email, l: lang(), t: Date.now() };
      lsSet(PEND, JSON.stringify(pass));
      if (form.getAttribute('data-hcaptcha-bound')) { armWatch(); return; }
      e.stopImmediatePropagation();
      viaFetch();
    });
  }

  /* ---------- Arranque ---------- */
  function startPage() {
    if (started) return;
    started = true;
    root.classList.add('is-started');
    $$('.p26-chip').forEach(function (c, i) { c.style.setProperty('--k', String(i)); });
    if (heroEl) heroEl.classList.add('is-go');
    initReveal();
  }

  initFit();
  makeNoise();
  updateLive();
  setInterval(updateLive, 30000);
  initCountdowns();
  initVideo();
  initMarquee();
  initScroll();
  initMap();
  initStrip();
  initBar();
  initMenu();
  initAnchors();
  initMagnet();
  initRsvp();

  startPage();
})();
